import en from "./english";
import du from "./dutch";
export const DROPDOWN = {
  en,
  du,
};
